import { Box, Grid, IconButton, Paper, Stack, Typography } from "@mui/material";
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import axiosClient from '../../lib/axios';
import { useQuery } from 'react-query';
import LoadingApiQuery from '../LoadingApiQuery';
import useMutateRascunho, { TRascunhoComponentes } from '../../lib/useMutateRascunho';
import { IDataRascunho, IRascunhoArquivo } from '../../types/api/financeiro/pesquisar-rascunhos';
import moment from 'moment';

export default function DisplayListagemRascunhos({
  componente,
  onDownloadForm,
  queryFields = {},
}: DisplayListagemRascunhosProps) {

  const { handleDeleteRascunho, isLoadingRemoverRascunho } = useMutateRascunho(componente);

  // query dos rascunhos
  const { data: resultRascunhos, isLoading: isLoadingRascunhos } = useQuery({
    queryKey: ["lista-pesquisar-rascunhos", queryFields],
    queryFn: () =>
      axiosClient.get("/pesquisar-rascunhos", {
        params: { componente, ...queryFields },
      }),
  });

  const dataRascunhos: IDataRascunho[] = resultRascunhos?.data || [];

  const RascunhoItem = ({ item }: { item: IDataRascunho }) => {
    const { id, arquivos, dados, created_at, usuario_nome } = item;

    return (
      <Box
        component={Paper}
        sx={{
          p: 1.5,
          minWidth: 200,
          flex: "0 0 auto",
          mr: 2,
          mb: componente === "GerarOrdemCompra" ? 2 : 0,
        }}
      >
        <Grid container spacing={2}>
          <Grid size={{xs: 7}}>
            <Typography variant="subtitle2" fontWeight="bold">
              Rascunho
            </Typography>
            <Typography variant="caption">
              {moment(created_at).format("DD/MM/YYYY HH:mm")}
            </Typography>
            <Typography variant="caption" display="block">
              {usuario_nome}
            </Typography>

            <Box mt={0.7} display="flex" alignItems="center" gap={1}>
              <Typography variant="h5" fontWeight="bold" color="primary">
                {arquivos.length}
              </Typography>
              <Typography variant="body1">arquivo(s)</Typography>
            </Box>
          </Grid>

          <Grid size={{xs: 5}} alignSelf="center">
            <Stack direction="row">
              <IconButton
                aria-label="use"
                onClick={() => onDownloadForm(dados, arquivos)}
              >
                <DownloadForOfflineOutlinedIcon />
              </IconButton>

              <IconButton
                aria-label="delete"
                disabled={isLoadingRemoverRascunho}
                onClick={() => handleDeleteRascunho(id)}
              >
                {isLoadingRemoverRascunho ? (
                  <LoadingApiQuery size={16} />
                ) : (
                  <DeleteOutlineOutlinedIcon />
                )}
              </IconButton>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    );
  };

  return (
    <Box mt={2}>
      {isLoadingRascunhos && <LoadingApiQuery size={25} />}

      {!isLoadingRascunhos && dataRascunhos.length > 0 && (
        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            scrollSnapType: "x mandatory",
            px: 1,
            py: 0.5,
            "&::-webkit-scrollbar": {
              height: 6,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(0,0,0,0.2)",
              borderRadius: 3,
            },
          }}
        >
          {dataRascunhos.map((rascunho, index) => (
            <Box
              key={index}
              sx={{
                scrollSnapAlign: "start",
              }}
            >
              <RascunhoItem item={rascunho} />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}

interface DisplayListagemRascunhosProps {
  componente: TRascunhoComponentes;
  onDownloadForm: (data: string, arquivos: IRascunhoArquivo[]) => void;
  queryFields?: {
    chave: string;
    tipo_valor: "string" | "int";
    valor: string;
  } | {};
}
